import { fetchFamilyAttributes } from '@gn-audio/core/api/product-catalogue/fetch-family-attributes';
import { fetchGroupAttributes } from '@gn-audio/core/api/product-catalogue/fetch-group-attributes';
export var fetchAttributes = function (productId, productType) {
    if (productType === void 0) { productType = "f" /* Family */; }
    var promise;
    switch (productType) {
        case "g" /* Group */:
            promise = fetchGroupAttributes(productId)
                .then(function (p) { return ((p === null || p === void 0 ? void 0 : p.attributes) || []); });
            break;
        case "f" /* Family */:
        default:
            promise = fetchFamilyAttributes(productId)
                .then(function (products) {
                return (products || [])
                    .map(function (p) { return (p.attributes || []); })
                    .reduce(function (accumulator, current) { return (accumulator.concat(current)); }, []);
            });
            break;
    }
    return promise.then(function (attributes) { return (attributes.map(function (a) { return (a.key + "|" + a.valueKey); })); });
};
